import { useMutation } from "react-query";
import { z } from "zod";
import api from "api";

const PartnerPatientPayloadSchema = z.object({
  alt_language: z.string().nonempty("errors.required"),
  email: z.string().email("errors.invalid_email").nonempty("errors.required"),
  invite_timezone: z.string().nullable(),
  invited_joint: z.string().nullable(),
  language_code: z.string().nonempty("errors.required"),
  patient_first_name: z.string().nonempty("errors.required"),
  patient_last_name: z.string().nonempty("errors.required"),
  phone_country_code: z.string().nonempty("errors.required"),
  phone_number: z.string().nullable(),
  us_provider_group_clinic_id: z.string(),

  // ChenMed specific fields
  file: z.any().nullable(),
  invite_clinic: z.string().optional(),
  invite_source: z.string().optional(),
  physician_first_name: z.string().optional(),
  physician_last_name: z.string().optional(),
  source: z.string().nullable(),

  // Motion MSK specific fields
  external_partner_user_id: z.string().optional(),
});
export type ProviderPatientPayload = z.infer<typeof PartnerPatientPayloadSchema>;

export const usePostProviderGroupPatient = () => {
  return useMutation<any, Error, ProviderPatientPayload>(data => {
    const formData = new FormData();
    formData.append("alt_language", data.alt_language);
    formData.append("email", data.email);
    if (data.invite_timezone) {
      formData.append("invite_timezone", data.invite_timezone);
    }
    if (data.invited_joint) {
      formData.append("invited_joint", data.invited_joint);
    }
    formData.append("language_code", data.language_code);
    formData.append("patient_first_name", data.patient_first_name);
    formData.append("patient_last_name", data.patient_last_name);
    formData.append("phone_country_code", data.phone_country_code);
    if (data.phone_number) {
      formData.append("phone_number", data.phone_number);
    }
    formData.append("us_provider_group_clinic_id", data.us_provider_group_clinic_id);

    // ChenMed specific fields
    if (data.file) {
      const [doc] = data.file;
      formData.append("file", doc, doc.name);
    }
    if (data.invite_clinic) {
      formData.append("invite_clinic", data.invite_clinic);
    }
    if (data.invite_source) {
      formData.append("invite_source", data.invite_source);
    }
    if (data.physician_first_name) {
      formData.append("physician_first_name", data.physician_first_name);
    }
    if (data.physician_last_name) {
      formData.append("physician_last_name", data.physician_last_name);
    }
    if (data.source) {
      formData.append("source", data.source);
    }

    // Motion MSK specific fields
    if (data.external_partner_user_id) {
      formData.append("external_partner_user_id", data.external_partner_user_id);
    }
    // @ts-ignore
    return api.parse("POST /invitations/provider_group_patient", { data: formData });
  });
};
